import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import MenuPage from "./pages/MenuPage";
import ContactPage from "./pages/ContactPage";
import ScrollToTop from "./components/ui/ScrollToTop";
import Admin from "./admin/Admin.jsx";
import "./i18n";
import OurStory from "./pages/OurStory";
import PdfViewer from "./pages/PdfViewer";
import MenuImagesPublic from "./components/sections/MenuImagesPublic";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* 🌐 Public Website Routes */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about" element={<Layout><AboutPage /></Layout>} />
        <Route path="/menu" element={<Layout><MenuPage /></Layout>} />
        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
        <Route path="/middaydiscount" element={<Layout><MenuImagesPublic /></Layout>} />
        <Route path="/our-story" element={<Layout><OurStory /></Layout>} />
        <Route path="/pdf/:id" element={<PdfViewer />} />

        {/* 🔐 Admin Route (shows login first, then dashboard) */}
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </>
  );
}
